// product-protect.js
(function () {
  function isProductPage() {
    return document.body.classList.contains('template-product');
  }

  // 右クリック防止（ズーム・モーダル含めて完全捕捉）
  document.addEventListener(
    'contextmenu',
    function (e) {
      if (!isProductPage()) return;
      e.preventDefault();
      return false;
    },
    true // ← これが超重要（キャプチャフェーズ）
  );

  // 画像ドラッグ防止（ズーム含む）
  document.addEventListener(
    'dragstart',
    function (e) {
      if (!isProductPage()) return;
      if (e.target && e.target.tagName === 'IMG') {
        e.preventDefault();
        return false;
      }
    },
    true
  );

  // 長押し対策（スマホ）
  document.addEventListener(
    'touchstart',
    function (e) {
      if (!isProductPage()) return;
      if (e.target && e.target.tagName === 'IMG') {
        e.preventDefault();
      }
    },
    { passive: false }
  );
})();
